var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protocol-popup"},[(_vm.protocolType === 'content')?_c('div',{staticClass:"protocol-content",domProps:{"innerHTML":_vm._s(_vm.protocolContent)}}):_c('div',[_c('iframe',{staticStyle:{"height":"8.5rem"},attrs:{"id":"modle_iframe","src":_vm.protocolUrl,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }